import { httpPost, httpGet } from '@/utils/service'

export async function create ({
  companyName,
  emailAddress,
  contactNumber,
  blInvList,
  areaCode,
  countryCode
}) {
  try {
    const response = await httpPost('CREATE_PO', {
      data: {
        companyName,
        emailAddress,
        contactNumber,
        blInvList,
        areaCode,
        countryCode
      }
    })
    return response.data
  } catch (error) {
    if (error.response && error.response.data) {
      throw error.response.data
    }

    throw error
  }
}

export async function getOne (poUid, {
  countryCode
}) {
  try {
    const response = await httpGet('GET_PO_DETAILS', {
      params: {
        poUid
      },
      config: {
        params: {
          countryCode,
          timestamp: `${new Date().getTime()}`
        }
      }
    })

    return response.data
  } catch (error) {
    if (error.response && error.response.data) {
      throw error.response.data
    }

    throw error
  }
}
